import { Link } from 'react-router'
import { VpIcon, VpProgressBar } from '@vtmn-play/react'
import './index.css'

type DiagTopBarProps = {
  currentIndex: number
  total: number
}

const DiagTopBar = ({ currentIndex, total }: DiagTopBarProps) => {
  const percentage = Math.round((currentIndex / total) * 100)
  return (
    <header className="sticky h-16 flex items-center justify-between px-4">
      <div className="flex items-center justify-center">
        <Link to="/" viewTransition>
          <VpIcon data-testid="close-icon" name="close" />
        </Link>
      </div>

      <div className="flex items-center w-3/7">
        <span className="mt-1 mr-2">
          {currentIndex}/{total}
        </span>
        <VpProgressBar value={percentage} />
      </div>
    </header>
  )
}

export default DiagTopBar
